import { Processor } from '@/features/html2react/types';

import * as processorsList from '../list';

export const processors = (initiator?: string): Processor[] =>
  (Object.values(processorsList) as Processor[]).filter(({ name }) => name !== initiator);
